import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UbiIdleService } from 'uber-ui';

import { AuthService } from 'modules/core/services/auth.service';

import { AppState } from 'store/root-reducer';
import * as AuthActions from 'store/actions/auth.actions';
import * as DomanActions from 'store/actions/domain.actions';

import { environment } from 'environments/environment';

@Injectable()
export class EnforcedMFAGuard implements CanActivate {
  constructor(private authService: AuthService,
              private store: Store<AppState>,
              private ubiIdleService: UbiIdleService,
              private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.authService
      .getUser(true)
      .pipe(
        map((user: any) => {
          if (user.preferredMFA !== 'NOMFA') {
            return true;
          } else {
            if (environment.ENFORCE_2FA) {
              this.router.navigateByUrl('mfa/setup');
              return false;
            } else {
              return true;
            }
          }
        }),
        catchError(() => {
          this.authService.logOut().subscribe();
          this.ubiIdleService.setBrowserLogout();
          this.ubiIdleService.setAuthState('signedOut');
          this.router.navigateByUrl('login');
          this.store.dispatch(new DomanActions.ClearLoadList());
          this.store.dispatch(new AuthActions.ClearGetUser());
          return of(false);
        })
      );
  }
}
